import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import classNames from 'classnames'
import { FormEvent } from 'react'
import { Button, FormControl, InputLabel, OutlinedInput } from 'ui'
import { LoaderInCentalPosition } from 'widget'

import style from 'feature/auth/AuthForm.module.scss'

type Props = {
  email: string
  hasError: boolean
  errorText: string | null
  isEmailValid: boolean
  isLoading: boolean
  onChange: (e: { target: { value: string } }) => void
  onBlur: () => void
  onSubmit: (e: FormEvent<HTMLFormElement>) => void
  hasForbiddenComTld: (email: string) => boolean
}

export function MagicLinkEmailForm({
  email,
  hasError,
  errorText,
  isEmailValid,
  isLoading,
  onChange,
  onBlur,
  onSubmit,
  hasForbiddenComTld,
}: Props) {
  const inBlockedDomain = hasForbiddenComTld(email)

  return (
    <div className={classNames(style.formWrapper, 'mt24')}>
      <form className={style.authForm} noValidate onSubmit={onSubmit}>
        <p className='h1'>Введите email</p>
        <p className={classNames(style.subtitle, 'mb24')}>
          Введите email, чтобы войти или зарегистрироваться
        </p>

        <FormControl className={style.authFormControl} error={hasError}>
          <InputLabel htmlFor='company-email-input'>Email</InputLabel>
          <OutlinedInput
            label='Email'
            fullWidth
            type='email'
            value={email}
            id='company-email-input'
            onChange={onChange}
            onBlur={onBlur}
            autoComplete='email'
            name='email'
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault()
                const form = (e.target as HTMLInputElement).closest('form')
                form?.requestSubmit()
              }
            }}
            inputProps={{
              'data-testid': 'company-login-email-input',
            }}
          />
        </FormControl>

        {(hasError || errorText) && (
          <p className={style.errorText}>
            {errorText || 'Введите корректный email'}
          </p>
        )}

        {inBlockedDomain && (
          <p className={style.errorText}>
            В связи с новым законодательством, вы не можете зарегистрировать
            аккаунт на инстроанный почтовый адрес (заканчивается на “.com”).
            Пожалуйста, воспользуйтесь другой почтой
          </p>
        )}

        <Button
          className={style.btn}
          type='submit'
          variant='contained'
          disabled={!isEmailValid || isLoading || inBlockedDomain}
          endIcon={<ChevronRightIcon />}
          data-testid='company-login-submit'
        >
          {isLoading && <LoaderInCentalPosition className={style.loader} />}
          Далее
        </Button>
      </form>
    </div>
  )
}
